var _rect, _g, _path, _ellipse, _g2, _path2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 160,
    viewBox: "0 0 280 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1157_63255)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 160,
    rx: 8,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("rect", {
    width: 258,
    height: 129,
    transform: "translate(11 16)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.25,
    x: -8,
    y: -4,
    width: 296,
    height: 169,
    fill: "#FCF3DF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M242.995 73.2226C232.182 68.6112 221.184 72.8491 216.54 83.123L226.731 88.7821C228.847 83.82 233.411 81.7397 238.077 83.7296C242.15 85.4667 243.848 89.0794 242.3 92.7084C239.079 100.263 226.867 94.0046 221.245 107.188L231.688 111.641C234.467 105.124 248.073 110.576 254.106 96.43C257.991 87.3204 253.364 77.6445 242.995 73.2226ZM219.588 126.263C223.365 127.874 227.591 126.174 229.17 122.471C230.749 118.768 229.019 114.617 225.241 113.006C221.39 111.363 217.196 112.988 215.617 116.691C214.037 120.395 215.737 124.62 219.588 126.263Z",
    fill: "#FEE4A8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M50.2131 14.1678C27.6733 25.4783 19.365 49.3596 29.7477 71.2055L53.1408 62.3656C47.9503 52.022 50.8708 41.6667 60.5968 36.7861C69.0878 32.5253 77.3564 34.7535 81.1524 42.3183C89.0543 58.0652 61.8797 69.3825 75.6693 96.8625L97.4373 85.9392C90.6199 72.3536 118.408 57.6366 103.611 28.1496C94.0821 9.16065 71.8265 3.32203 50.2131 14.1678ZM104.602 126.02C112.475 122.069 115.552 112.795 111.678 105.076C107.805 97.3568 98.6082 94.4347 90.7347 98.3857C82.7068 102.414 79.5529 111.534 83.4264 119.253C87.2999 126.972 96.5739 130.048 104.602 126.02Z",
    fill: "#FEE4A8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.956 34.9869C148.482 38.3054 145.638 38.8743 141.75 37.9261C140.77 39.5064 138.223 43.2358 135.872 45.5113C133.623 47.6874 131.263 45.7016 131 43.6718C130.891 42.8292 130.427 41.5907 129.849 40.9679C128.997 40.0489 128.566 38.6318 129.844 37.4518C130.466 36.8775 130.732 35.7477 130.481 34.9394C130.002 33.3988 130.329 31.4402 132.909 31.3078C133.614 31.2716 134.233 30.7196 134.469 30.0534C135.279 27.7622 138.27 26.4706 140.52 28.1996C140.942 28.5236 141.511 28.6304 142.007 28.4374C144.451 27.4852 145.562 28.8919 145.951 30.2318C146.097 30.7312 146.478 31.15 146.955 31.3582C148.031 31.8284 149.252 32.9184 148.956 34.9869Z",
    fill: "#D69702"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1157_63255",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 133,
    y: 30,
    width: 15,
    height: 20
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 140.386,
    cy: 40.1659,
    rx: 6.63704,
    ry: 9.86074,
    transform: "rotate(-7.28534 140.386 40.1659)",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1157_63255)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 140.386,
    cy: 40.1659,
    rx: 6.63704,
    ry: 9.86074,
    transform: "rotate(-7.28534 140.386 40.1659)",
    fill: "#FEE4A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.491 40.0121C135.397 41.8136 134.164 42.6669 132.647 42.4773V29.2032L142.603 26.738C145.068 29.0452 149.467 34.1715 147.343 36.2195C144.688 38.7795 142.697 34.418 141.37 35.8403C140.043 37.2625 139.094 36.978 137.198 36.504C137.862 39.9173 135.586 38.2106 135.491 40.0121Z",
    fill: "#D69702"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M139.64 46.2274C139.79 44.9257 141.952 44.0182 143.101 44.8729",
    stroke: "#D69702",
    strokeWidth: 1.204
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1157_63255",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 107,
    y: 96,
    width: 19,
    height: 18
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.338 108.675L108.184 98.3474C112.502 96.485 120.883 96.5696 123.338 97.8395C125.302 98.8554 124.833 100.915 124.354 101.818C125.956 103.145 126.241 104.017 125.285 105.882C127.825 109.861 119.952 112.739 117.581 113.416C115.211 114.093 112.671 111.384 116.311 109.522C112.112 110.199 108.58 109.24 107.338 108.675Z",
    fill: "#AE5848"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1157_63255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.338 108.675L108.184 98.3474C112.502 96.485 120.883 96.5696 123.338 97.8395C125.302 98.8554 124.833 100.915 124.354 101.818C125.956 103.145 126.241 104.017 125.285 105.882C127.825 109.861 119.952 112.739 117.581 113.416C115.211 114.093 112.671 111.384 116.311 109.522C112.112 110.199 108.58 109.24 107.338 108.675Z",
    fill: "#FEE4A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.967 109.522L113.009 110.538M120.967 105.035C122.096 104.725 124.776 104.476 126.47 105.966M120.967 101.141C123.253 100.887 124.946 101.141 126.724 102.157",
    stroke: "#D69702",
    strokeWidth: 1.18519,
    strokeLinejoin: "bevel"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1157_63255",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 140,
    y: 23,
    width: 26,
    height: 15
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M151.837 23.3216C155.985 23.9142 160.133 28.0623 165.551 33.311C166.115 33.9883 166.161 35.3089 161.488 36.8666C156.815 38.4242 152.317 34.7219 151.075 32.5491C148.874 34.1576 142.271 36.8666 144.387 32.7184C142.609 33.565 141.364 31.6856 142.779 30.6867C141.932 31.1099 139.562 30.4327 141.339 28.401C143.117 26.3692 147.689 22.729 151.837 23.3216Z",
    fill: "#AE5848"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1157_63255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.837 23.3216C155.985 23.9142 160.133 28.0623 165.551 33.311C166.115 33.9883 166.161 35.3089 161.488 36.8666C156.815 38.4242 152.317 34.7219 151.075 32.5491C148.874 34.1576 142.271 36.8666 144.387 32.7184C142.609 33.565 141.364 31.6856 142.779 30.6867C141.932 31.1099 139.562 30.4327 141.339 28.401C143.117 26.3692 147.689 22.729 151.837 23.3216Z",
    fill: "#FEE4A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.451 30.0093C146.013 30.7485 144.642 31.7871 142.61 33.2262M146.928 27.4696C144.473 28.3162 143.256 29.2611 141.34 31.1945",
    stroke: "#D69702",
    strokeWidth: 1.18519,
    strokeLinejoin: "bevel"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1157_63255",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 27,
    width: 135,
    height: 89
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M165.882 91.9132H126.096C124.826 90.3047 125.23 87.8908 126.388 83.0243L127.32 78.3682L98.5366 94.0295C101.161 93.8602 107.561 93.8264 112.166 95.0454L109.203 112.315C102.939 113.275 87.3282 115.227 75.0022 115.363C59.5948 115.532 56.7165 101.225 74.4097 90.3047C92.1028 79.384 112.759 67.7862 120.039 64.3999C127.32 61.0137 135.447 58.3893 145.267 57.9661C155.087 57.5428 166.769 57.2888 174.727 68.8867C167.751 57.3735 158.953 43.7156 155.426 38.3258L168.547 27.4899C170.353 30.5375 177.267 42.1862 190.473 64.3999C206.981 92.1671 188.018 100.379 177.775 90.3047C169.58 82.2454 165.5 78.481 164.484 77.6063C166.685 83.0243 168.168 88.4423 165.882 91.9132Z",
    fill: "#01B388"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1157_63255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.882 91.9132H126.096C124.826 90.3047 125.23 87.8908 126.388 83.0243L127.32 78.3682L98.5366 94.0295C101.161 93.8602 107.561 93.8264 112.166 95.0454L109.203 112.315C102.939 113.275 87.3282 115.227 75.0022 115.363C59.5948 115.532 56.7165 101.225 74.4097 90.3047C92.1028 79.384 112.759 67.7862 120.039 64.3999C127.32 61.0137 135.447 58.3893 145.267 57.9661C155.087 57.5428 166.769 57.2888 174.727 68.8867C167.751 57.3735 158.953 43.7156 155.426 38.3258L168.547 27.4899C170.353 30.5375 177.267 42.1862 190.473 64.3999C206.981 92.1671 188.018 100.379 177.775 90.3047C169.58 82.2454 165.5 78.481 164.484 77.6063C166.685 83.0243 168.168 88.4423 165.882 91.9132Z",
    fill: "#FCBB26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.887 93.4374L101.077 114.093M101.331 93.1834C97.2675 93.3245 85.9913 95.2829 78.8125 100.972M137.141 56.612L141.458 64.231L145.352 58.3051M145.352 58.3051L150.347 63.8924L153.564 57.3739M145.352 58.3051C147.158 65.5291 150.686 84.2268 150.347 92.4215M169.564 62.5379L182.516 81.2469M158.305 44.3368L173.204 32.3157",
    stroke: "#D69702",
    strokeWidth: 1.18519
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.167 70.7493C151.897 69.8603 151.752 68.9777 151.701 68.2943L159.151 67.9557C159.312 68.6197 159.44 69.5033 159.429 70.4107M152.167 70.7493C152.79 72.7971 154.081 74.8796 156.442 74.6435C158.751 74.4126 159.407 72.357 159.429 70.4107M152.167 70.7493L159.429 70.4107",
    stroke: "#D69702",
    strokeWidth: 1.18519
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1157_63255",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 119,
    y: 91,
    width: 91,
    height: 138
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M164.614 91.6547H124.826C121.919 96.0286 117.088 108.671 121.016 124.247C125.926 143.718 116.529 203.655 129.482 218.893H161.058C160.325 217.284 158.654 211.832 157.841 202.893C157.029 193.953 152.423 127.972 152.423 127.972C152.423 127.972 160.972 198.356 181.884 225.119C191.111 236.929 210.153 216.607 209.729 202.893C209.729 196.205 199.063 181.902 192.84 166.495C186.618 151.088 177.469 119.769 172.692 110.495C167.916 101.221 165.545 93.5735 164.614 91.6547Z",
    fill: "#EAEBF0"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1157_63255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.614 91.6547H124.826C121.919 96.0286 117.088 108.671 121.016 124.247C125.926 143.718 116.529 203.655 129.482 218.893H161.058C160.325 217.284 158.654 211.832 157.841 202.893C157.029 193.953 152.423 127.972 152.423 127.972C152.423 127.972 160.972 198.356 181.884 225.119C181.884 225.119 210.153 216.607 209.729 202.893C209.729 196.205 199.063 181.902 192.84 166.495C186.618 151.088 177.469 119.769 172.692 110.495C167.916 101.221 165.545 93.5735 164.614 91.6547Z",
    fill: "#D69702"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.899 96.2528L156.864 95.7084L156.319 95.6982L150.573 95.5907L149.948 95.579L149.97 96.2033L150.582 114.278L150.613 115.199L151.438 114.788C152.182 114.418 153.673 113.554 154.978 112.234C156.282 110.916 157.455 109.085 157.418 106.799C157.376 104.244 157.14 100.008 156.899 96.2528Z",
    stroke: "#FCBB26",
    strokeWidth: 1.18519
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1157_63255"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 160,
    rx: 8,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.333d65e3ec9b4556499db3e36f889306.svg";
export { ForwardRef as ReactComponent };